<template>
  <v-row>
    <v-col class="align-left">
      <ExpandCollapseToggle
        id="loadRatingsPanelToggle"
        @toggleAllPanels="toggleAllPanels"
        styleClass="mt-3"
        :panel="panel"
      />
    </v-col>
    <v-col class="align-right mt-2">
      <ValidationCountsHeader v-if="isManagement" />
    </v-col>
  </v-row>
  <div v-if="!isTunnel">
    <v-form ref="loadRatingsForm" v-model="validLoadRatings">
      <v-row :class="$vuetify?.display?.mdAndDown ? 'mt-1' : 'mt-3'">
        <v-col xl="5" lg="12" md="12" sm="12" cols="12" class="d-sm-block d-md-flex py-0">
          <LabelCheckbox
            labelXl="5"
            labelLg="9"
            labelMd="9"
            labelSm="10"
            id="recommendedReview"
            class="noGridCheckbox handleFlex pr-2 pb-0"
            label="LR.01 Load Rating Review Recommended"
            :isEditable="isEditable && !isManagement"
            noGrid
            v-model="loadRatingValue.RECOMMEND_RATING_REVIEW"
            @update:modelValue="checkChangeReviewerAction()"
          ></LabelCheckbox>
          <v-btn id="btn_considerations" variant="outlined" @click="showConsiderationsDialog = true"
            >Considerations</v-btn
          >
        </v-col>
        <v-col xl="4" lg="12" md="12" sm="12" cols="12" class="py-0">
          <LabelSelect
            class="reviewActionField"
            noGrid
            id="reviewerAction"
            label="LR.02 Reviewer Action"
            :isEditable="isEditable && isManagement"
            :refTable="REFERENCE_TABLE.REVIEWER_ACTION"
            v-model="loadRatingValue.LR_REVIEW_ACTION"
          ></LabelSelect>
        </v-col>
        <v-col xl="3" lg="12" md="12" sm="12" class="py-0">
          <LabelCheckbox
            class="noGridCheckbox handleFlex pr-2 pb-0"
            noGrid
            id="postingReviewRecommended"
            label="LR.03 Posting Review Recommended"
            v-model="loadRatingValue.POST_REVIEW_REC"
            @update:model-value="loadRatingsForm.validate()"
            :isEditable="isEditable"
          ></LabelCheckbox>
        </v-col>
      </v-row>
      <v-row v-if="isManagement">
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Posting Review Recommended Summary"
            id="field_Posting_Review_Recommended_Summary_Management"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_POSTING_RECOMMENDED_SUMMARY"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="loadRatingValue.inspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            @updateComment="
              (comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.LOAD_RATING_POSTING_RECOMMENDED_SUMMARY)
            "
            :isRequired="loadRatingValue.POST_REVIEW_REC === '1'"
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Previous Posting Review Recommended Summary"
            id="field_Previous_Posting_Review_Recommended_Summary_Management"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_POSTING_RECOMMENDED_SUMMARY"
            readonly
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :previousComments="loadRatingValue.previousInspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            previousData
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Inspection Team Notes"
            id="field_Inspection_Team_Notes_Management"
            :inspectionCommentType="INSPECTION_COMMENTS.REVIEW_RECOMMENDED_DUE_TO_COMMENTS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="loadRatingValue.inspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            secondCharacterCount
            @updateComment="
              (comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.REVIEW_RECOMMENDED_DUE_TO_COMMENTS)
            "
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Previous Inspection Team Notes"
            id="field_Previous_Inspection_Team_Notes_Management"
            :inspectionCommentType="INSPECTION_COMMENTS.REVIEW_RECOMMENDED_DUE_TO_COMMENTS"
            readonly
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :previousComments="loadRatingValue.previousInspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            previousData
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Load Rating Engineer Notes"
            id="field_Load_Rating_Engineer_Notes_Management"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_REVIEW"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :comments="loadRatingValue.inspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.LOAD_RATING_REVIEW)"
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <ManagementCommentTypeTextField
            class="details-text"
            label="Previous Load Rating Engineer Notes"
            id="field_Previous_Load_Rating_Engineer_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_REVIEW"
            readonly
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :previousComments="loadRatingValue.previousInspectionComments"
            :brkey="loadRatingValue.BRKEY"
            :inspectionId="loadRatingValue.INSPECTIONID"
            previousData
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <CommentTypeTextField
            class="details-text"
            label="Inspection Team Notes"
            id="field_Inspection_Team_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.REVIEW_RECOMMENDED_DUE_TO_COMMENTS"
            :readonly="!isEditable"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            secondCharacterCount
            :isRequired="!isEditable"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <CommentTypeTextField
            class="details-text"
            label="Posting Review Recommended Summary"
            id="field_Posting_Review_Recommended_Summary_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_POSTING_RECOMMENDED_SUMMARY"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            :readonly="!isEditable"
            :isRequired="loadRatingValue.POST_REVIEW_REC === '1'"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <CommentTypeTextField
            label="Previous Inspection Team Notes"
            id="field_Previous_Inspection_Team_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.REVIEW_RECOMMENDED_DUE_TO_COMMENTS"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            readonly
            previousData
          />
        </v-col>
        <v-col xl="6" lg="6" md="12" sm="12" cols="12">
          <CommentTypeTextField
            label="Previous Load Rating Engineer Notes"
            id="field_Previous_Load_Rating_Engineer_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.LOAD_RATING_REVIEW"
            :counter="inspCommentMaxLength"
            :maxlength="inspCommentMaxLength"
            readonly
            previousData
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="6" md="12" sm="12">
          <v-row>
            <v-col>
              <LabelSelect
                v-if="isManagement"
                noGrid
                id="calculationDates"
                label="LR.04 Calculation Date"
                v-model="shownCalculationDate"
                :options="calculationDates"
                :isEditable="isEditable && isManagement"
                @update:modelValue="getLoadRatingDetails()"
              />
              <LabelDatefield
                v-else
                noGrid
                label="LR.04 Calculation Date"
                id="calculationDate"
                v-model="shownCalculationDate"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                :disabled="!isEditable || addingOrEditing"
                id="btn_add_Posting"
                variant="outlined"
                class="mr-1"
                @click="showAddRatingSetDialog = true"
                v-if="isManagement"
                >Add New Rating Set</v-btn
              >
              <v-btn
                :disabled="!isEditable || addingOrEditing"
                class="ml-1"
                id="btn_assign_Rating_Set"
                variant="outlined"
                @click="assignRatingSet()"
                v-if="isManagement"
                >Assign Rating Set</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col lg="6" md="12" sm="12">
          <v-row>
            <v-col>
              <LabelDatefield
                noGrid
                label="LR.05 Assigned Rating Approval Date"
                id="approvalDate"
                v-model="loadRatingValue.RATING_APPR_DATE"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <LabelText
                type="text"
                noGrid
                label="LR.06 Assigned Rating Approval Engineer"
                id="approvalEngineer"
                counter="45"
                maxlength="45"
                v-model="loadRatingValue.APPROVER_NAME"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
  <v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel v-if="!isTunnel" class="mt-5" :value="0">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
          <h3>Load Ratings Details</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="!isEditable || addingOrEditing || !canEditRatingSet"
                id="btn_add_Posting"
                variant="outlined"
                class="mr-1"
                @click="addRating"
                v-if="isManagement"
                >Add Load Type</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-data-table
                v-model:expanded="expandedRows"
                :headers="isManagement ? detailsHeadersEditable : detailsHeaders"
                :items="loadRatingDetails"
                class="lessPaddingTableColumns"
                :items-per-page="-1"
                v-model:sort-by="sortBy"
                hide-default-footer
                must-sort
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.LOAD_TYPE`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.NBI_RATING_IND`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.RATING_ANALYSIS_METHOD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.IRLOAD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.ORLOAD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.SLC_RATING`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.IR_LOAD_FACTOR`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.OR_LOAD_FACTOR`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.SUPPORT_DATASET`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.action`]="{ column }" v-if="isManagement">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>

                <template v-slot:item="{ item }">
                  <tr :class="rowClassDetails(item)">
                    <td class="text-center">
                      <button v-if="!expandedRows.includes(item)" @click="toggleRowDetails(item)">
                        <v-icon :id="`icon_Chevron_Right_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-right"></v-icon>
                      </button>

                      <button v-else-if="expandedRows.includes(item)" @click="toggleRowDetails(item)">
                        <v-icon :id="`icon_Chevron_Down_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-down"></v-icon>
                      </button>
                    </td>
                    <td class="text-center">
                      {{
                        item?.LOAD_TYPE ? configStore.getReferenceValue(REFERENCE_TABLE.LOAD_TYPE, item?.LOAD_TYPE) : ""
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.NBI_RATING_IND
                          ? configStore.getReferenceValue(REFERENCE_TABLE.NBI_RATING, item?.NBI_RATING_IND)
                          : ""
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.RATING_ANALYSIS_METHOD
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.LOAD_RATING_METHOD,
                              item?.RATING_ANALYSIS_METHOD,
                            )
                          : ""
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.IRLOAD
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.ORLOAD
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.SLC_RATING
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        Number.parseFloat(item.IR_LOAD_FACTOR)
                          ? Number.parseFloat(item.IR_LOAD_FACTOR).toFixed(2)
                          : item.IR_LOAD_FACTOR
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        Number.parseFloat(item.OR_LOAD_FACTOR)
                          ? Number.parseFloat(item.OR_LOAD_FACTOR).toFixed(2)
                          : item.OR_LOAD_FACTOR
                      }}
                    </td>
                    <td class="text-center">
                      {{ item.SUPPORT_DATASET }}
                    </td>
                    <td class="alignCenter" v-if="isManagement">
                      <div
                        style="white-space: nowrap"
                        v-if="!item.readOnly && addingOrEditing && isEditable && canEditRatingSet"
                      >
                        <IconTooltip
                          :id="`icon_add_${item.POSTING_KEY}`"
                          icon="fa-solid fa-check"
                          :tooltip="item?.isAdd ? 'Add' : 'Update'"
                          @click="saveRating(item)"
                        />
                        <IconTooltip
                          :id="`icon_close_${item.POSTING_KEY}`"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeRating"
                        />
                      </div>
                      <div
                        style="white-space: nowrap"
                        v-else-if="isEditable && expandedRows?.length == 0 && !addingOrEditing && canEditRatingSet"
                      >
                        <IconTooltip
                          :id="`icon_edit_${item.UNIQUE_KEY}`"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editRating(item)"
                        />
                        <IconTooltip
                          :id="`icon_edit_${item.UNIQUE_KEY}`"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteRating(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="isManagement ? detailsHeadersEditable.length : detailsHeaders.length">
                    <v-form ref="loadRatingsDetailsForm" v-model="validLoadRatingsDetails" class="mt-2">
                      <v-row class="mt-1">
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pb-0'"
                        >
                          <LabelDatefield
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="calcDate"
                            label="LR.04 Calculation Date"
                            v-model="item.RATING_DATE"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pt-0 pb-0'"
                        >
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="loadType"
                            label="B.EP.01 Load Type"
                            v-model="item.LOAD_TYPE"
                            :refTable="REFERENCE_TABLE.LOAD_TYPE"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            :isRequired="isEditable && isManagement && !item.readOnly"
                            @update:model-value="updateOnLoadTypeOrRatingMethodChange(item)"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="nbiRating"
                            label="LR.07 NBI"
                            v-model="item.NBI_RATING_IND"
                            :refTable="REFERENCE_TABLE.NBI_RATING"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            :isRequired="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="ratingMethod"
                            label="LR.08 Load Rating Method"
                            v-model="item.RATING_ANALYSIS_METHOD"
                            :refTable="REFERENCE_TABLE.LOAD_RATING_METHOD"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            :isRequired="isEditable && isManagement && !item.readOnly"
                            @update:model-value="updateOnLoadTypeOrRatingMethodChange(item)"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="memberType"
                            label="LR.09 Ctrl Member Type"
                            v-model="item.CONTROL_MEM_TYPE"
                            :refTable="REFERENCE_TABLE.CONTROLLING_MEMBER_TYPE"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="stressCategoryType"
                            label="LR.10 Fatigue Stress Category"
                            v-model="item.FATIG_STRESS_CAT"
                            :refTable="REFERENCE_TABLE.CONTROLLING_MEMBER_FATIGUE_STRESS_CATEGORY"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="fatigueLoadType"
                            label="LR.11 Fatigue Load Type"
                            v-model="item.FATIG_LOAD_TYPE"
                            :refTable="REFERENCE_TABLE.FATIGUE_LOAD_TYPE"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            id="manYr"
                            :counter="false"
                            :maxlength="4"
                            label="LR.12 AASHTO Man Yr"
                            v-model="item.AASHTO_MANUAL_YEAR"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            :counter="false"
                            :maxlength="4"
                            id="specYr"
                            label="LR.13 AASHTO Spec Yr"
                            v-model="item.AASHTO_SPEC_YEAR"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            type="text"
                            label="LR.14 Engineer"
                            id="engineer"
                            v-model="item.ANALYSIS_ENGINEER"
                            counter="30"
                            maxlength="30"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pt-0'"
                        >
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="invRating"
                            label="LR.15 Inventory Rating"
                            v-model="item.IRLOAD"
                            appendWith=" Tons"
                            :roundingFactor="
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                                ? ROUNDING_FACTOR.ROUND_DOWN
                                : ROUNDING_FACTOR.ROUND
                            "
                            type="number"
                            :isEditable="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :maxlength="3"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="operatorRating"
                            label="LR.16 Operating Rating"
                            v-model="item.ORLOAD"
                            appendWith=" Tons"
                            :roundingFactor="
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                                ? ROUNDING_FACTOR.ROUND_DOWN
                                : ROUNDING_FACTOR.ROUND
                            "
                            type="number"
                            :isEditable="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :maxlength="3"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999);
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="slcRating"
                            label="LR.17 SLC Rating"
                            v-model="item.SLC_RATING"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            :isEditable="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="changesDetectedRating = true"
                            :maxlength="3"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(
                                        value,
                                        0,
                                        item.ORLOAD,
                                      );
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="irRatingFactor"
                            label="LR.18 IR Rating Factor"
                            v-model="item.IR_LOAD_FACTOR"
                            :maxlength="4"
                            :decimalPlaces="2"
                            type="number"
                            :isEditable="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 3);
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="orRatingFactor"
                            label="LR.19 OR Rating Factor"
                            v-model="item.OR_LOAD_FACTOR"
                            :maxlength="4"
                            :decimalPlaces="2"
                            type="number"
                            :isEditable="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              isEditable &&
                              isManagement &&
                              !item.readOnly &&
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 3);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="critInventory"
                            label="LR.20 Govern Crit Inventory"
                            v-model="item.INV_RATING_STRESS_METHOD"
                            :refTable="REFERENCE_TABLE.GOVERNING_CRITERIA"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />

                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="critOperating"
                            label="LR.21 Govern Crit Operating"
                            :refTable="REFERENCE_TABLE.GOVERNING_CRITERIA"
                            v-model="item.OPR_RATING_STRESS_METHOD"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          ></LabelSelect>

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="stressRange"
                            label="LR.22 Stress Range"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            :decimalPlaces="1"
                            v-model="item.STRESS_RANGE"
                            appendWith=" ksi"
                            type="number"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                            :maxlength="5"
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999.9);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="legalLoadRatingFactor"
                            label="B.EP.02 Legal Load Rating Factor"
                            :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                            :decimalPlaces="2"
                            v-model="item.LEGAL_LOAD_RF"
                            type="number"
                          />
                          <div>
                            <v-row>
                              <v-col xl="5" sm="6">
                                <v-label class="bold">B.EP.03 Vehicle Posting Type: </v-label></v-col
                              >
                              <v-col class="pl-4">{{
                                loadRatingStore.vehiclePostTypesDisplayValue(item.lrVehiclePostTypes)
                              }}</v-col>
                            </v-row>
                          </div>
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="vehiclePostingValue"
                            label="B.EP.04 Vehicle Posting Value"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            v-model="item.VEH_POST_WEIGHT"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col sm="12" class="pb-0">
                          <LabelText
                            style="padding-left: 4px !important; padding-bottom: 0px !important"
                            labelXl="12"
                            labelLg="12"
                            labelMd="12"
                            labelSm="12"
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            type="textarea"
                            label="LR.23 Rating Dataset"
                            id="ratingDataset"
                            v-model="item.SUPPORT_DATASET"
                            counter="100"
                            maxlength="100"
                            persistentCounter
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col sm="12" class="pt-0 pb-0">
                          <LabelText
                            style="
                              padding-left: 4px !important;
                              padding-top: 0px !important;
                              padding-bottom: 4px !important;
                            "
                            labelXl="12"
                            labelLg="12"
                            labelMd="12"
                            labelSm="12"
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            type="textarea"
                            label="LR.24 Notes"
                            id="notes"
                            v-model="item.NOTES"
                            :counter="notesMaxLength"
                            :maxlength="notesMaxLength"
                            persistentCounter
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </td> </template
                ><template v-slot:bottom> </template></v-data-table></v-col
          ></v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="!isTunnel" :value="1"
        ><v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />
          <h3>NBI & Alternate Ratings</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-form ref="nbiAndAlternateRatingsForm" v-model="validNbiAndAlternateRatings">
            <v-label class="bold pt-2">NBI:</v-label>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="designLoad"
                  label="B.LR.01 Design Load"
                  :isEditable="isEditable && isManagement"
                  :refTable="REFERENCE_TABLE.DESIGN_LOAD"
                  v-model="loadRatingValue.DESIGNLOAD"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" lg="6" xl="6">
                <LabelDatefield
                  class="pt-1"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  label="B.LR.03 Rating Date"
                  id="ratingDate"
                  v-model="nbiAndAlternateRating.ratingDate"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6">
                <LabelText
                  v-if="isRF(nbiAndAlternateRating.nbi1RatingAnalysisMethod, nbiAndAlternateRating.nbi1LoadType, true)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="inventoryRating"
                  label="B.LR.05 Inventory Rating"
                  v-model="nbiAndAlternateRating.nbi1IRLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                />
                <LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="inventoryRating"
                  label="B.LR.05 Inventory Rating"
                  v-model="nbiAndAlternateRating.nbi1IRLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="inventoryRating"
                  label="B.LR.04 Operating Rating Method"
                  :refTable="REFERENCE_TABLE.OPERATING_RATING_METHOD"
                  v-model="nbiAndAlternateRating.nbi1OperatingRatingMethod"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="isRF(nbiAndAlternateRating.nbi1RatingAnalysisMethod, nbiAndAlternateRating.nbi1LoadType, true)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="operatingRating"
                  label="B.LR.06 Operating Rating"
                  v-model="nbiAndAlternateRating.nbi1ORLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                />
                <LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="operatingRating"
                  label="B.LR.06 Operating Rating"
                  v-model="nbiAndAlternateRating.nbi1ORLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6"
                ><LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  label="B.LR.02 Design Method"
                  id="designMethod"
                  :isRequired="isDesignMethodRequired"
                  :isEditable="isEditable && isManagement"
                  :refTable="REFERENCE_TABLE.DESIGN_METHOD"
                  v-model="loadRatingValue.DESIGN_METHOD"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6">
                <LabelText
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="controllingLegalLoadRatingFactor"
                  label="B.LR.07 Controlling Legal Load Rating Factor"
                  :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                  :decimalPlaces="2"
                  v-model="nbiAndAlternateRating.controllingLegalLoadRatingFactor"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6"
                ><LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  label="B.LR.08 Routine Permit Loads"
                  id="routinePermitLoads"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  :refTable="REFERENCE_TABLE.ROUTINE_PERMIT_LOADS"
                  v-model="loadRatingValue.ROUTINE_PERMIT_LOADS"
                  :isEditable="isEditable && isManagement"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6">
                <LabelText
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="penndotControllingLegalLoadRatingFactor"
                  label="LR.25 Controlling Penndot Legal Load Rating Factor"
                  :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                  :decimalPlaces="2"
                  v-model="nbiAndAlternateRating.penndotControllingLegalLoadRatingFactor"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-label class="bold pt-2">Alternate:</v-label>
            <v-row class="pl-6 pt-1">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="isRF(nbiAndAlternateRating.h20RatingAnalysisMethod, nbiAndAlternateRating.h20LoadType, false)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="inventoryRating"
                  label="LR.26 H20 Inventory Rating"
                  v-model="nbiAndAlternateRating.h20IRLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="inventoryRating"
                  label="LR.26 H20 Inventory Rating"
                  v-model="nbiAndAlternateRating.h20IRLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="isRF(nbiAndAlternateRating.h20RatingAnalysisMethod, nbiAndAlternateRating.h20LoadType, false)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="operatingRating"
                  label="LR.27 H20 Operating Rating"
                  v-model="nbiAndAlternateRating.h20ORLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="operatingRating"
                  label="LR.27 H20 Operating Rating"
                  v-model="nbiAndAlternateRating.h20ORLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6"
                ><LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  label="LR.28 H20 Operating Type"
                  id="operatingType"
                  :refTable="REFERENCE_TABLE.LOAD_RATING_METHOD"
                  v-model="nbiAndAlternateRating.h20RatingAnalysisMethod"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="isRF(nbiAndAlternateRating.ml80RatingAnalysisMethod, nbiAndAlternateRating.ml80LoadType, false)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="ml80InventoryRating"
                  label="LR.29 ML80 Inventory Rating"
                  v-model="nbiAndAlternateRating.ml80IRLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="ml80InventoryRating"
                  label="LR.29 ML80 Inventory Rating"
                  v-model="nbiAndAlternateRating.ml80IRLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="isRF(nbiAndAlternateRating.ml80RatingAnalysisMethod, nbiAndAlternateRating.ml80LoadType, false)"
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="ml80OperatingRating"
                  label="LR.30 ML80 Operating Rating"
                  v-model="nbiAndAlternateRating.ml80ORLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="ml80OperatingRating"
                  label="LR.30 ML80 Operating Rating"
                  v-model="nbiAndAlternateRating.ml80ORLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6"
                ><LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  label="LR.31 ML80 Operating Type"
                  id="ml80OperatingType"
                  :refTable="REFERENCE_TABLE.LOAD_RATING_METHOD"
                  v-model="nbiAndAlternateRating.ml80RatingAnalysisMethod"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="
                    isRF(nbiAndAlternateRating.tk527RatingAnalysisMethod, nbiAndAlternateRating.tk527LoadType, false)
                  "
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="tk527InventoryRating"
                  label="LR.32 TK527 Inventory Rating"
                  v-model="nbiAndAlternateRating.tk527IRLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="tk527InventoryRating"
                  label="LR.32 TK527 Inventory Rating"
                  v-model="nbiAndAlternateRating.tk527IRLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row class="pl-6">
              <v-col cols="12" lg="6" xl="6"
                ><LabelText
                  v-if="
                    isRF(nbiAndAlternateRating.tk527RatingAnalysisMethod, nbiAndAlternateRating.tk527LoadType, false)
                  "
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="tk527OperatingRating"
                  label="LR.33 TK527 Operating Rating"
                  v-model="nbiAndAlternateRating.tk527ORLoadFactor"
                  :decimalPlaces="2"
                  type="number"
                /><LabelText
                  v-else
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  textXl="6"
                  textLg="6"
                  textMd="6"
                  textSm="6"
                  id="tk527OperatingRating"
                  label="LR.33 TK527 Operating Rating"
                  v-model="nbiAndAlternateRating.tk527ORLoad"
                  appendWith=" Tons"
                  :roundingFactor="ROUNDING_FACTOR.ROUND"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6" xl="6"
                ><LabelSelect
                  labelXl="6"
                  labelLg="6"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  label="LR.34 TK527 Operating Type"
                  id="tk527OperatingType"
                  :refTable="REFERENCE_TABLE.LOAD_RATING_METHOD"
                  v-model="nbiAndAlternateRating.tk527RatingAnalysisMethod"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        :class="$vuetify?.display?.mdAndDown ? 'mt-1' : 'mt-3'"
        v-if="isTunnel && loadRatingValue.tunnelLoadRating"
        :value="2"
      >
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(2)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(2)" icon="fa-solid fa-minus" />
          <h3>Load Ratings Details</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col
              ><LabelSelect
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                selectXl="7"
                selectLg="6"
                selectMd="6"
                selectSm="6"
                label="L.1 Rating Method"
                id="lRatingMethod"
                :refTable="REFERENCE_TABLE.TUNNEL_LOAD_RATING_METHOD"
                v-model="loadRatingValue.tunnelLoadRating.ratingMethod"
              />
            </v-col>
            <v-col
              ><LabelText
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                textXl="6"
                textLg="4"
                textMd="4"
                textSm="4"
                label="L.7 Posting Load - Type 3"
                id="type3PostLoad"
                v-model="loadRatingValue.tunnelLoadRating.type3PostLoad"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><LabelText
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                label="L.2 Inventory Rating Factor"
                id="invLRFactor"
                v-model="loadRatingValue.tunnelLoadRating.invLrFactor"
              />
            </v-col>
            <v-col
              ><LabelText
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                textXl="6"
                textLg="4"
                textMd="4"
                textSm="4"
                label="L.8 Posting Load - Type 3S2"
                id="type33s2PostLoad"
                v-model="loadRatingValue.tunnelLoadRating.type3S2PostLoad"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><LabelText
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                label="L.3 Operating Rating Factor"
                id="oplrFactor"
                v-model="loadRatingValue.tunnelLoadRating.opLrFactor"
              />
            </v-col>
            <v-col
              ><LabelText
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                textXl="6"
                textLg="4"
                textMd="4"
                textSm="4"
                label="L.9 Posting Load - Type 3-3"
                id="type33PostLoad"
                v-model="loadRatingValue.tunnelLoadRating.type33PostLoad"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><LabelSelect
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                selectXl="7"
                selectLg="6"
                selectMd="6"
                selectSm="6"
                label="L.4 Load Posting Status"
                id="postStatus"
                :refTable="REFERENCE_TABLE.POSTING_STATUS"
                :value="activePostingRecord?.POST_STATUS"
              />
            </v-col>
            <v-col
              ><LabelSelect
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="6"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.10 Height Restriction"
                :isEditable="isEditable && isManagement"
                id="heightRestriction"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="loadRatingValue.tunnelLoadRating.heightRestr"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><LabelText
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                label="L.5 Posting Load - Gross"
                id="loadGross"
                v-model="loadRatingValue.tunnelLoadRating.grossPostLoad"
              />
            </v-col>
            <v-col
              ><LabelSelect
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="6"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.11 Hazardous Material Restriction"
                :isEditable="isEditable && isManagement"
                id="heightRestriction"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="loadRatingValue.tunnelLoadRating.hazmatRestr"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><LabelText
                labelXl="5"
                labelLg="6"
                labelMd="6"
                labelSm="6"
                label="L.6 Posting Load - Axle"
                id="loadAxle"
                v-model="loadRatingValue.tunnelLoadRating.axlePostLoad"
              />
            </v-col>
            <v-col
              ><LabelSelect
                labelXl="6"
                labelLg="8"
                labelMd="8"
                labelSm="8"
                selectXl="6"
                selectLg="4"
                selectMd="4"
                selectSm="4"
                label="L.12 Other Restrictions"
                id="otherRestriction"
                :isEditable="isEditable && isManagement"
                :refTable="REFERENCE_TABLE.YES_NO"
                v-model="loadRatingValue.tunnelLoadRating.otherRestr"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :value="3">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panel.includes(3)" icon="fa-solid fa-plus" />
          <v-icon v-if="panel.includes(3)" icon="fa-solid fa-minus" />
          <h3>Posting History</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="!isEditable || addingOrEditing || !isAssignedRatingSetSelected"
                id="btn_add_Posting"
                variant="outlined"
                @click="addPosting"
                v-if="isManagement"
                >Add Posting</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-data-table
                v-model:expanded="expandedRowsPosting"
                :headers="isManagement ? headersPostingEditable : headersPosting"
                :items="postingHistory"
                class="lessPaddingTableColumns"
                v-model:sort-by="sortByPosting"
                :items-per-page="-1"
                hide-default-footer
                must-sort
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.POST_STATUS_DATE`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.POST_STATUS`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.SPEC_RESTRICT_POST`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.POST_LIMIT_WEIGHT`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.POST_LIMIT_COMB`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.POST_REASON`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>
                <template v-slot:[`header.action`]="{ column }" v-if="isManagement">
                  <DataTableHeader :column="column" :sortBy="sortByPosting" />
                </template>

                <template v-slot:item="{ item }">
                  <tr :class="rowClassPosting(item)">
                    <td class="text-center">
                      <button v-if="!expandedRowsPosting.includes(item)" @click="toggleRowPosting(item)">
                        <v-icon
                          :id="`icon_Chevron_Right_${item.POST_STATUS_DATE}`"
                          icon="fa-solid fa-chevron-right"
                        ></v-icon>
                      </button>

                      <button v-else-if="expandedRowsPosting.includes(item)" @click="toggleRowPosting(item)">
                        <v-icon
                          :id="`icon_Chevron_Down_${item.POST_STATUS_DATE}`"
                          icon="fa-solid fa-chevron-down"
                        ></v-icon>
                      </button>
                    </td>
                    <td class="text-center">
                      {{ getFormattedDateStringNoTime(item?.POST_STATUS_DATE) }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.POST_STATUS
                          ? configStore.getReferenceValue(REFERENCE_TABLE.POSTING_STATUS, item?.POST_STATUS)
                          : ""
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.SPEC_RESTRICT_POST
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.SPECIAL_RESTRICT_POST,
                              item?.SPEC_RESTRICT_POST,
                            )
                          : ""
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.POST_LIMIT_WEIGHT
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.POST_LIMIT_COMB
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item?.POST_REASON
                          ? configStore.getReferenceValue(REFERENCE_TABLE.POST_REASON, item?.POST_REASON)
                          : ""
                      }}
                    </td>
                    <td class="alignCenter" v-if="isManagement">
                      <div style="white-space: nowrap" v-if="!item.readOnly && addingOrEditing && isEditable">
                        <IconTooltip
                          :id="`icon_add_${item.POSTING_KEY}`"
                          icon="fa-solid fa-check"
                          :tooltip="item?.isAdd ? 'Add' : 'Update'"
                          @click="savePosting(item)"
                        />
                        <IconTooltip
                          :id="`icon_close_${item.POSTING_KEY}`"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closePosting"
                        />
                      </div>
                      <div
                        style="white-space: nowrap"
                        v-else-if="
                          isEditable &&
                          expandedRowsPosting?.length == 0 &&
                          !addingOrEditing &&
                          isAssignedRatingSetSelected
                        "
                      >
                        <IconTooltip
                          :id="`icon_edit_${item.UNIQUE_KEY}`"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editPosting(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:expanded-row="{ item }">
                  <td :colspan="isManagement ? headersPostingEditable.length : headersPosting.length">
                    <v-form ref="postingHistoryForm" v-model="validPostingHistory" class="mt-2">
                      <v-row class="mt-1">
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? 'px-1' : 'py-0'"
                        >
                          <LabelDatefield
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            textXl="6"
                            textLg="5"
                            textMd="5"
                            textSm="5"
                            id="txt_Status_Date"
                            label="B.PS.02 Status Date"
                            v-model="item.POST_STATUS_DATE"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            :isRequired="isEditable && isManagement && !item.readOnly"
                            @update:modelValue="changesDetected = true"
                          >
                          </LabelDatefield>

                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Posting_Status"
                            label="PS.01 Posting Status"
                            :refTable="REFERENCE_TABLE.POSTING_STATUS"
                            v-model="item.POST_STATUS"
                          ></LabelSelect>
                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Posting_Type"
                            label="B.PS.01 Posting Type"
                            :refTable="REFERENCE_TABLE.POSTING_TYPE"
                            v-model="item.SNBI_POST_STATUS"
                            @update:modelValue="updatePostingStatus(item)"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            :isRequired="isEditable && isManagement && !item.readOnly"
                          ></LabelSelect>
                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Posting_Condition"
                            label="B.PS.01 Posting Condition"
                            :refTable="REFERENCE_TABLE.POSTING_CONDITION"
                            v-model="item.SNBI_POST_CONDITION"
                            @update:modelValue="updatePostingStatus(item)"
                            :isEditable="
                              isEditable && isManagement && !item.readOnly && postingHistoryConditionEditable(item)
                            "
                            :isRequired="
                              isEditable && isManagement && !item.readOnly && postingHistoryConditionRequired(item)
                            "
                          ></LabelSelect>
                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Special_Restrictive_Posting"
                            label="PS.02 Special Restrictive Posting"
                            :refTable="REFERENCE_TABLE.SPECIAL_RESTRICT_POST"
                            v-model="item.SPEC_RESTRICT_POST"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                          ></LabelSelect>

                          <LabelSelect
                            v-if="isEditable && isManagement && !item.readOnly && isVehiclePostingTypeEditable(item)"
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Vehicle_Posting_Type"
                            label="PS.03 Vehicle Posting Type"
                            :options="getVehiclePostTypeOptions(item)"
                            v-model="item.pVehiclePostTypes"
                            :multiSelect="true"
                            :clearable="!isGrossLoadLocked(item)"
                            :itemProps="true"
                            :isEditable="
                              isEditable && isManagement && !item.readOnly && isVehiclePostingTypeEditable(item)
                            "
                            :isRequired="
                              isEditable && isManagement && !item.readOnly && isVehiclePostingTypeRequired(item)
                            "
                            @update:model-value="changesDetectedPosting = true"
                          ></LabelSelect>
                          <div v-else>
                            <v-row>
                              <v-col xl="6" sm="7"> <v-label class="bold">PS.03 Vehicle Posting Type: </v-label></v-col>
                              <v-col class="pl-4">{{
                                loadRatingStore.vehiclePostTypesDisplayValue(item.pVehiclePostTypes)
                              }}</v-col>
                            </v-row>
                          </div>

                          <LabelText
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            textXl="6"
                            textLg="5"
                            textMd="5"
                            textSm="5"
                            id="txt_Posted Weight Limit"
                            label="PS.04 Posted Weight Limit"
                            :textStyle="'width: 80%'"
                            v-model="item.POST_LIMIT_WEIGHT"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            maxlength="2"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                            :isRequired="postingFieldRequired(item) && isEditable && isManagement && !item.readOnly"
                          />

                          <LabelText
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            textXl="6"
                            textLg="5"
                            textMd="5"
                            textSm="5"
                            id="txt_Posted_Limit_Combination"
                            label="PS.05 Posted Limit Combination"
                            :textStyle="'width: 80%'"
                            v-model="item.POST_LIMIT_COMB"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            maxlength="2"
                            class="mb-2"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                            :isRequired="postingFieldRequired(item) && isEditable && isManagement && !item.readOnly"
                          />
                        </v-col>

                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? 'px-1' : 'py-0'"
                        >
                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Posting_Reason"
                            label="PS.06 Posting Reason"
                            :refTable="REFERENCE_TABLE.POST_REASON"
                            v-model="item.POST_REASON"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                            :isRequired="
                              (item.SNBI_POST_STATUS == 'C' && isEditable && isManagement && !item.readOnly) ||
                              (postingFieldRequired(item) && isEditable && isManagement && !item.readOnly)
                            "
                          ></LabelSelect>

                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Field_Conditions"
                            label="PS.07 Field Conditions"
                            :refTable="REFERENCE_TABLE.FIELD_COND"
                            v-model="item.FIELD_COND"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                          ></LabelSelect>

                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_Special_Conditions"
                            label="PS.08 Special Conditions"
                            :refTable="REFERENCE_TABLE.SPECIAL_CONDITIONS"
                            v-model="item.SPEC_COND"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                          ></LabelSelect>

                          <LabelSelect
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            selectXl="6"
                            selectLg="5"
                            selectMd="5"
                            selectSm="5"
                            id="sel_AASHTO_Impact_Code"
                            label="PS.09 AASHTO Impact Code"
                            :refTable="REFERENCE_TABLE.AASHTO_IMPACT_CODE"
                            v-model="item.IMPACT"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                          ></LabelSelect>
                          <LabelCheckbox
                            v-if="isManagement"
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            editIndent
                            class="labelCheckbox"
                            id="checkbox_ Permanently_Closed_Structure"
                            label="PS.10 Permanently Closed Structure"
                            v-model="item.PERMANENTLY_CLOSED_STRUC"
                            :isEditable="isEditable && isManagement && !item.readOnly"
                            @update:model-value="changesDetectedPosting = true"
                          >
                          </LabelCheckbox>
                          <LabelCheckbox
                            labelXl="6"
                            labelLg="7"
                            labelMd="7"
                            labelSm="7"
                            class="labelCheckbox"
                            id="checkbox_Active"
                            label="PS.11 Active"
                            v-model="item.ACTIVE"
                          >
                          </LabelCheckbox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </td>
                </template>

                <template v-slot:bottom> </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>

  <v-dialog v-model="showConsiderationsDialog" scrollable persistent class="dialogForm">
    <v-card>
      <v-card-title> Considerations: </v-card-title>
      <v-divider />
      <v-card-text>
        <ul class="pl-3">
          <li v-for="(item, id) in CONSIDERATIONS_POINTS" :key="id">
            {{ item }}
          </li>
        </ul>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          variant="outlined"
          class="mx-5"
          @click="
            {
              showConsiderationsDialog = false;
            }
          "
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
  <RatingSetPopup
    :show="showAddRatingSetDialog"
    :brkey="loadRatingValue.BRKEY"
    :ratingSet="loadRatingDetails"
    :activePostingRecord="activePostingRecord"
    :postingHistory="postingHistory"
    @addRatingSet="(addRatingSetObject) => addRatingSet(addRatingSetObject)"
    @close="closeRatingSetPopup"
  />
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import { clone } from "@/util/clone";
import { useConfigStore } from "@/stores/config";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import { getStructureType } from "@/composables/structureType";
import {
  MODULE_TYPES,
  CONSIDERATIONS_POINTS,
  INSPECTION_MESSAGES,
  STRUCTURE_TYPE,
} from "@/constants/InspectionConstants";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import { getFormattedDateStringNoTime, getISOFormattedDateNoTime } from "@/composables/dateField.js";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useLoadRatingStore } from "@/components/inspection/store/loadRating";
import { useQuickSearchStore } from "@/stores/quickSearch";
import {
  LOAD_RATING_AND_POSTING_DATA,
  POSTING,
  RATING_LOAD,
  NBI_AND_ALTERNATE_RATING,
} from "@/constants/LoadRatingAndPosting.js";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import RatingSetPopup from "@/components/inspection/RatingSetPopup.vue";
import { useSnackbarStore } from "@/stores/snackbar";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { BUTTONS, COMMON_MESSAGE_CONSTANTS } from "@/constants/CommonWebConstants";
import { SNACKBAR_MARKER, SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";
import { LOGGER } from "@/util/logger";
import IconTooltip from "@/components/common/IconTooltip.vue";
import { LOAD_RATING_AND_POSTING_PERMISSIONS, ACCESS_LEVELS } from "@/rbac";
import { useUserPermissionStore } from "@/stores/userPermission";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { valueInRangeRule } from "@/composables/validationRules";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default {
  name: "InspectionLoadRatings",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    let loadRatingValue = ref(clone(LOAD_RATING_AND_POSTING_DATA));
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const isTunnel = computed(() => {
      return getStructureType(loadRatingValue.value.SERVTYPON) === STRUCTURE_TYPE.TUNNEL;
    });
    const nbiAndAlternateRating = computed(() => {
      if (loadRatingValue.value.nbiAndAlternateRating) {
        return loadRatingValue.value.nbiAndAlternateRating;
      } else {
        return NBI_AND_ALTERNATE_RATING;
      }
    });
    const allPanels = [0, 1, 2, 3];
    const tunnelPanels = [2];
    let panel = ref(isTunnel.value ? tunnelPanels : allPanels);
    const inspectionStore = useInspectionStore();
    const loadRatingStore = useLoadRatingStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const userStore = useUserStore();
    const snackbarStore = useSnackbarStore();
    const structure = computed(() => inspectionStore.selectedInspection);
    const userPermissionStore = useUserPermissionStore();
    let postingHistoryForm = ref();
    let validPostingHistory = ref(true);
    let validLoadRatingsDetails = ref(true);
    let loadRatingsDetailsForm = ref();
    let changesDetectedPosting = ref(false);
    let changesDetectedRating = ref(false);
    let snackBarId = ref(null);
    let ratingSetAssigned = ref(false);
    let shownCalculationDate = ref(null);
    let ratingLoads = [];

    const closeConfirm = ref(null);

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            LOAD_RATING_AND_POSTING_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(loadRatingValue.value.BRKEY),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            LOAD_RATING_AND_POSTING_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(loadRatingValue.value.BRKEY),
          );
        }
      },
    });

    let addingOrEditing = computed({
      get() {
        return (
          inspectionLinksStore.isAddingOrEditingLoadRatingDetails ||
          inspectionLinksStore.isAddingOrEditingLoadRatingPostingDetails
        );
      },
    });

    let addingOrEditingLoadRatingDetails = computed({
      get() {
        return inspectionLinksStore.isAddingOrEditingLoadRatingDetails;
      },
      set(value) {
        inspectionLinksStore.isAddingOrEditingLoadRatingDetails = value;
      },
    });

    let addingOrEditingLoadRatingPostingDetails = computed({
      get() {
        return inspectionLinksStore.isAddingOrEditingLoadRatingPostingDetails;
      },
      set(value) {
        inspectionLinksStore.isAddingOrEditingLoadRatingPostingDetails = value;
      },
    });

    const isManagement = computed(() => props.moduleType == MODULE_TYPES.MANAGEMENT);

    let validationSnackbar = computed({
      get() {
        return inspectionLinksStore.showValidationSnackbar;
      },
      set(value) {
        inspectionLinksStore.showValidationSnackbar = value;
      },
    });

    let duplicateLoadTypeValidationSnackbar = ref(false);
    let duplicateLoadTypeTextId = ref("");

    let showConsiderationsDialog = ref(false);
    let loadRatingsForm = ref();
    let nbiAndAlternateRatingsForm = ref();
    let showAddRatingSetDialog = ref(false);

    let validLoadRatings = ref(true);

    let validNbiAndAlternateRatings = ref(true);

    const valid = computed(() => validLoadRatings.value && validNbiAndAlternateRatings.value);

    let resetDirty = ref(false);

    const validate = async () => {
      await loadRatingsForm.value?.validate();
      await nbiAndAlternateRatingsForm.value?.validate();
    };

    const isAssignedRatingSetSelected = computed(
      () =>
        getFormattedDateStringNoTime(shownCalculationDate.value) ==
        getFormattedDateStringNoTime(loadRatingValue.value.RATING_DATE),
    );

    const isShownRatingSetAssignedToAnInspection = computed(() =>
      loadRatingValue.value.assignedRatingDates?.some(
        (assignedRatingDate) =>
          getFormattedDateStringNoTime(assignedRatingDate) === getFormattedDateStringNoTime(shownCalculationDate.value),
      ),
    );

    onMounted(async () => {
      await readData();
    });

    const readData = async () => {
      loadRatingDetails.value = [];
      ratingLoads = [];
      postingHistory.value = [];
      loadRatingValue.value = clone(LOAD_RATING_AND_POSTING_DATA);
      resetDirty.value = true;
      if (isManagement.value && structureHeader.value?.BRKEY) {
        await loadRatingStore.loadLoadRatingObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );
        loadRatingValue.value = loadRatingStore.getLoadRatingObject();
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        await loadRatingStore.loadLoadRatingObject(props.moduleType, null, null, structure.value);
        loadRatingValue.value = loadRatingStore.getLoadRatingObject();
      } else {
        return;
      }
      if (!isTunnel.value) {
        shownCalculationDate.value = loadRatingStore
          ?.getCalculationDates()
          ?.find(
            (date) =>
              getFormattedDateStringNoTime(date) == getFormattedDateStringNoTime(loadRatingValue.value.RATING_DATE),
          );
        ratingLoads = clone(loadRatingValue.value.ratingLoads) || [];
        getLoadRatingDetails();
      } else if (!loadRatingValue.value.tunnelLoadRating) {
        loadRatingValue.value.tunnelLoadRating = LOAD_RATING_AND_POSTING_DATA.tunnelLoadRating;
      }
      resetDirty.value = true;
      getPostingHistoryDetails();
      await validate();
    };
    let sortByPosting = ref([{ key: "POST_STATUS_DATE", order: "desc" }]);
    let previousSortByPosting = ref([{ key: "POST_STATUS_DATE", order: "desc" }]);
    const headersPostingEditable = ref([
      {
        key: "data-table-expand",
        width: "3%",
      },
      {
        line1: "B.PS.02",
        line2: "Status",
        line3: "Date",
        key: "POST_STATUS_DATE",
        sortable: true,
      },
      {
        line1: "PS.01",
        line2: "Posting",
        line3: "Status",
        key: "POST_STATUS",
        sortable: true,
      },
      {
        line1: "PS.02",
        line2: "Special Restrictive",
        line3: "Posting",
        key: "SPEC_RESTRICT_POST",
        sortable: true,
      },
      {
        line1: "PS.04",
        line2: "Posted Weight",
        line3: "Limit (Tons)",
        key: "POST_LIMIT_WEIGHT",
        sortable: false,
      },
      {
        line1: "PS.05",
        line2: "Posted Limit",
        line3: "Combination (Tons)",
        key: "POST_LIMIT_COMB",
        sortable: false,
      },
      {
        line1: "PS.06",
        line2: "Posting",
        line3: "Reason",
        key: "POST_REASON",
        sortable: true,
      },
      {
        line1: null,
        line2: "Action",
        line3: null,
        key: "action",
        sortable: false,
        width: "5%",
      },
    ]);
    const headersPosting = ref([
      {
        key: "data-table-expand",
        width: "3%",
      },
      {
        line1: "B.PS.02",
        line2: "Status",
        line3: "Date",
        key: "POST_STATUS_DATE",
        sortable: true,
      },
      {
        line1: "PS.01",
        line2: "Posting",
        line3: "Status",
        key: "POST_STATUS",
        sortable: true,
      },
      {
        line1: "PS.02",
        line2: "Special Restrictive",
        line3: "Posting",
        key: "SPEC_RESTRICT_POST",
        sortable: true,
      },
      {
        line1: "PS.04",
        line2: "Posted Weight",
        line3: "Limit (Tons)",
        key: "POST_LIMIT_WEIGHT",
        sortable: false,
      },
      {
        line1: "PS.05",
        line2: "Posted Limit",
        line3: "Combination (Tons)",
        key: "POST_LIMIT_COMB",
        sortable: false,
      },
      {
        line1: "PS.06",
        line2: "Posting",
        line3: "Reason",
        key: "POST_REASON",
        sortable: true,
      },
    ]);

    let postingHistory = ref([]);

    const getPostingHistoryDetails = () => {
      expandedRowsPosting.value = [];
      postingHistory.value = [];
      postingHistory.value = clone(loadRatingValue.value.postings);
      if (!postingHistory.value?.[0]) {
        //remove null values from array(if any)
        postingHistory.value = postingHistory.value?.filter((a) => !!a);
      }
      //set readOnly
      for (const element of postingHistory.value ?? []) {
        element.readOnly = true;
      }
    };

    const activePostingRecord = computed(() => {
      return postingHistory?.value?.find((posting) => posting.ACTIVE === "1");
    });

    let expandedRowsPosting = ref([]);

    const rowClassPosting = (data) => {
      return expandedRowsPosting.value?.find((a) => a.POSTING_KEY === data.POSTING_KEY) ? "rowSelect" : "rowUnselect";
    };

    const toggleRowPosting = (detail) => {
      detail.pVehiclePostTypes = loadRatingStore.getVehiclePostTypes(detail.VEH_POST_TYPES);
      if (expandedRowsPosting.value.includes(detail)) {
        const index = expandedRowsPosting?.value?.findIndex((d) => d.POSTING_KEY == detail.POSTING_KEY);
        expandedRowsPosting.value.splice(index, 1);
      } else {
        expandedRowsPosting.value.push(detail);
      }
    };

    const closeRatingSetPopup = () => {
      showAddRatingSetDialog.value = false;
    };

    const isEditable = computed(() => {
      if (isManagement.value) {
        return !quickSearchStore.getErrorMessage() && loadRatingValue.value?.BRKEY && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });

    const isDesignMethodRequired = computed(() => {
      return (
        isEditable.value && isManagement.value && ["S1", "S2", "L1", "A1"].includes(structureHeader.value?.REPORTGROUP)
      );
    });

    const inspCommentMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    const notesMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.NOTES_MAX_LENGTH);
    });

    let expandedRows = ref([]);
    const configStore = useConfigStore();

    let sortBy = ref([{ key: "LOAD_TYPE", order: "asc" }]);
    let previousSortBy = ref([{ key: "LOAD_TYPE", order: "asc" }]);
    const detailsHeadersEditable = ref([
      {
        key: "data-table-expand",
        width: "3%",
      },
      {
        line1: "B.EP.01",
        line2: "Load",
        line3: "Type",
        key: "LOAD_TYPE",
        sortable: true,
      },
      {
        line1: "LR.07",
        line2: "NBI",
        line3: "",
        key: "NBI_RATING_IND",
        sortable: true,
      },
      {
        line1: "LR.08",
        line2: "Load Rating",
        line3: "Method",
        key: "RATING_ANALYSIS_METHOD",
        sortable: true,
      },
      {
        line1: "LR.15",
        line2: "IR",
        line3: "Tons",
        key: "IRLOAD",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.16",
        line2: "OR",
        line3: "Tons",
        key: "ORLOAD",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.17",
        line2: "SLC",
        line3: "Tons",
        key: "SLC_RATING",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.18",
        line2: "IR",
        line3: "RF",
        key: "IR_LOAD_FACTOR",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.19",
        line2: "OR",
        line3: "RF",
        key: "OR_LOAD_FACTOR",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.23",
        line2: "Rating",
        line3: "Dataset",
        key: "SUPPORT_DATASET",
        width: "12%",
        sortable: true,
      },
      {
        line1: null,
        line2: "Action",
        line3: null,
        key: "action",
        sortable: false,
      },
    ]);
    const detailsHeaders = ref([
      {
        key: "data-table-expand",
        width: "3%",
      },
      {
        line1: "B.EP.01",
        line2: "Load",
        line3: "Type",
        key: "LOAD_TYPE",
        sortable: true,
      },
      {
        line1: "LR.07",
        line2: "NBI",
        line3: "",
        key: "NBI_RATING_IND",
        sortable: true,
      },
      {
        line1: "LR.08",
        line2: "Load Rating",
        line3: "Method",
        key: "RATING_ANALYSIS_METHOD",
        sortable: true,
      },
      {
        line1: "LR.15",
        line2: "IR",
        line3: "Tons",
        key: "IRLOAD",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.16",
        line2: "OR",
        line3: "Tons",
        key: "ORLOAD",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.17",
        line2: "SLC",
        line3: "Tons",
        key: "SLC_RATING",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.18",
        line2: "IR",
        line3: "RF",
        key: "IR_LOAD_FACTOR",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.19",
        line2: "OR",
        line3: "RF",
        key: "OR_LOAD_FACTOR",
        sortable: true,
        width: "8%",
      },
      {
        line1: "LR.23",
        line2: "Rating",
        line3: "Dataset",
        key: "SUPPORT_DATASET",
        width: "12%",
        sortable: true,
      },
    ]);

    const convertToPostingObject = (details) => {
      let postingObject = clone(POSTING);
      postingObject.POSTING_ID = details.POSTING_ID;
      postingObject.BRKEY = details.BRKEY;
      postingObject.POSTING_KEY = details.POSTING_KEY;
      postingObject.ACTIVE = details.ACTIVE;
      postingObject.FIELD_COND = details.FIELD_COND;
      postingObject.IMPACT = details.IMPACT;
      postingObject.PERMANENTLY_CLOSED_STRUC = details.PERMANENTLY_CLOSED_STRUC;
      postingObject.POST_LIMIT_COMB = details.POST_LIMIT_COMB;
      postingObject.POST_LIMIT_WEIGHT = details.POST_LIMIT_WEIGHT;
      postingObject.POST_REASON = details.POST_REASON;
      postingObject.POST_STATUS = details.POST_STATUS;
      postingObject.POST_STATUS_DATE = details.POST_STATUS_DATE;
      postingObject.SNBI_POST_CONDITION = details.SNBI_POST_CONDITION;
      postingObject.SNBI_POST_STATUS = details.SNBI_POST_STATUS;
      postingObject.SPEC_COND = details.SPEC_COND;
      postingObject.SPEC_RESTRICT_POST = details.SPEC_RESTRICT_POST;
      postingObject.MODTIME = details.MODTIME;
      postingObject.USERKEY = details.USERKEY;
      postingObject.VEH_POST_TYPES = loadRatingStore.convertToVehPostTypeObjects(
        postingObject,
        details.pVehiclePostTypes,
        false,
      );

      return postingObject;
    };

    const cleanupPostingNullValues = () => {
      if (!loadRatingValue.value?.postings?.[0]) {
        //remove null values from array(if any)
        loadRatingValue.value.postings = loadRatingValue.value.postings?.filter((a) => !!a);
      }
    };

    const saveOrUpdatePosting = (detail) => {
      if (detail.isAdd) {
        updateActive(detail);
        loadRatingValue.value.postings.push(convertToPostingObject(detail));
      } else {
        //update existing detail
        const updateIndex = loadRatingValue?.value?.postings?.findIndex((a) => a.POSTING_KEY === detail.POSTING_KEY);
        loadRatingValue.value.postings.splice(updateIndex, 1, convertToPostingObject(detail));
      }
    };

    const updateRatingLoadsForCurrentDate = () => {
      for (const detail of ratingLoads ?? []) {
        if (
          getFormattedDateStringNoTime(shownCalculationDate.value) == getFormattedDateStringNoTime(detail.RATING_DATE)
        ) {
          updateOnLoadTypeOrRatingMethodChange(detail);
        }
      }
      getLoadRatingDetails();
    };

    const finalizePostingSave = () => {
      //if all required fields entered - close the expanded row
      expandedRowsPosting.value = [];
      addingOrEditingLoadRatingPostingDetails.value = false;
      snackbarStore.removeMessage(snackBarId.value);
      getPostingHistoryDetails();
      if (!isTunnel.value) {
        updateRatingLoadsForCurrentDate();
      }
      sortByPosting.value = previousSortByPosting.value?.map((x) => x);
    };

    const handlePostingValidationSuccess = (detail) => {
      cleanupPostingNullValues();
      changesDetectedPosting.value = false;
      saveOrUpdatePosting(detail);
      finalizePostingSave();
    };

    const savePosting = (detail) => {
      validationSnackbar.value = false;
      postingHistoryForm.value
        .validate()
        .then(() => {
          if (validPostingHistory.value) {
            handlePostingValidationSuccess(detail);
          } else {
            validationSnackbar.value = true;
          }
        })
        .catch((err) => {
          LOGGER.logException(err);
          changesDetectedPosting.value = false;
        });
    };

    const editPosting = (posting) => {
      previousSortByPosting.value = sortByPosting.value.map((x) => x);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.POSTINGS_DATATABLE,
      });
      posting.readOnly = false;
      posting.pVehiclePostTypes = loadRatingStore.getVehiclePostTypes(posting.VEH_POST_TYPES);
      addingOrEditingLoadRatingPostingDetails.value = true;
      expandedRowsPosting.value.push(posting);
    };

    let getNewPostingKey = () => {
      if (postingHistory.value.length > 0) {
        return Math.max.apply(
          null,
          postingHistory.value.map(function (postings) {
            return postings.POSTING_KEY + 1;
          }),
        );
      } else {
        return 1;
      }
    };

    const addPosting = () => {
      previousSortByPosting.value = sortByPosting.value.map((x) => x);
      sortByPosting.value = [];
      let newPosting = clone(POSTING);
      newPosting.BRKEY = loadRatingValue.value.BRKEY;
      newPosting.POSTING_KEY = getNewPostingKey();
      newPosting.ACTIVE = "1";
      newPosting.isAdd = true;
      postingHistory.value.unshift(newPosting);
      expandedRowsPosting.value.push(newPosting);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.POSTINGS_DATATABLE,
      });
      addingOrEditingLoadRatingPostingDetails.value = true;
      nextTick(() => {
        postingHistoryForm.value?.validate();
      });
    };

    const closePosting = () => {
      if (isEditable.value && changesDetectedPosting.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              changesDetectedPosting.value = false;
              getPostingHistoryDetails();
              expandedRowsPosting.value = [];
              addingOrEditingLoadRatingPostingDetails.value = false;
              validationSnackbar.value = false;
              snackbarStore.removeMessage(snackBarId.value);
              snackBarId.value = snackbarStore.showMessage({
                displayText: COMMON_MESSAGE_CONSTANTS.CHANGES_DISCARDED,
                timeout: 10000,
                messageType: SNACKBAR_MESSAGE_TYPES.SUCCESS,
              });
              sortBy.value = previousSortByPosting.value?.map((x) => x);
            }
          });
      } else {
        getPostingHistoryDetails();
        expandedRowsPosting.value = [];
        addingOrEditingLoadRatingPostingDetails.value = false;
        validationSnackbar.value = false;
        snackbarStore.removeMessage(snackBarId.value);
        sortByPosting.value = previousSortByPosting.value?.map((x) => x);
      }
    };

    const convertToRatingLoadObject = (details) => {
      let ratingLoadObject = clone(RATING_LOAD);
      ratingLoadObject.RATING_LOAD_ID = details.RATING_LOAD_ID;
      ratingLoadObject.BRKEY = details.BRKEY;
      ratingLoadObject.RATING_DATE = details.RATING_DATE;
      ratingLoadObject.RATING_KEY = details.RATING_KEY;
      ratingLoadObject.AASHTO_MANUAL_YEAR = details.AASHTO_MANUAL_YEAR;
      ratingLoadObject.AASHTO_SPEC_YEAR = details.AASHTO_SPEC_YEAR;
      ratingLoadObject.ANALYSIS_ENGINEER = details.ANALYSIS_ENGINEER;
      ratingLoadObject.CONTROL_MEM_TYPE = details.CONTROL_MEM_TYPE;
      ratingLoadObject.CREATEDATETIME = details.CREATEDATETIME;
      ratingLoadObject.CREATEUSERKEY = details.CREATEUSERKEY;
      ratingLoadObject.FATIG_LOAD_TYPE = details.FATIG_LOAD_TYPE;
      ratingLoadObject.FATIG_STRESS_CAT = details.FATIG_STRESS_CAT;
      ratingLoadObject.INV_RATING_STRESS_METHOD = details.INV_RATING_STRESS_METHOD;
      ratingLoadObject.IRLOAD = details.IRLOAD;
      ratingLoadObject.IR_LOAD_FACTOR = details.IR_LOAD_FACTOR;
      ratingLoadObject.LEGAL_LOAD_RF = details.LEGAL_LOAD_RF;
      ratingLoadObject.LOAD_TYPE = details.LOAD_TYPE;
      ratingLoadObject.NBI_RATING_IND = details.NBI_RATING_IND;
      ratingLoadObject.NOTES = details.NOTES;
      ratingLoadObject.OPR_RATING_STRESS_METHOD = details.OPR_RATING_STRESS_METHOD;
      ratingLoadObject.ORLOAD = details.ORLOAD;
      ratingLoadObject.OR_LOAD_FACTOR = details.OR_LOAD_FACTOR;
      ratingLoadObject.RATING_ANALYSIS_METHOD = details.RATING_ANALYSIS_METHOD;
      ratingLoadObject.SLC_RATING = details.SLC_RATING;
      ratingLoadObject.STRESS_RANGE = details.STRESS_RANGE;
      ratingLoadObject.SUPPORT_DATASET = details.SUPPORT_DATASET;
      ratingLoadObject.MODTIME = details.MODTIME;
      ratingLoadObject.USERKEY = details.USERKEY;
      ratingLoadObject.VEH_POST_WEIGHT = details.VEH_POST_WEIGHT;
      ratingLoadObject.VEH_POST_TYPES = loadRatingStore.convertToVehPostTypeObjects(
        ratingLoadObject,
        details.lrVehiclePostTypes,
        true,
      );

      return ratingLoadObject;
    };

    const saveRating = (detail) => {
      duplicateLoadTypeValidationSnackbar.value = false;
      validationSnackbar.value = false;
      loadRatingsDetailsForm.value
        .validate()
        .then(() => {
          const isValidLoadType = loadRatingStore.validateLoadType(detail, loadRatingDetails.value);
          if (validLoadRatingsDetails.value && isValidLoadType) {
            if (!ratingLoads?.[0]) {
              //remove null values from array(if any)
              ratingLoads = ratingLoads?.filter((a) => !!a);
            }
            updateOnLoadTypeOrRatingMethodChange(detail);
            changesDetectedRating.value = false;
            if (detail.isAdd) {
              ratingLoads.push(convertToRatingLoadObject(detail));
            } else {
              //update existing detail
              const updateIndex = ratingLoads?.findIndex(
                (a) => a.RATING_KEY === detail.RATING_KEY && a.RATING_DATE === detail.RATING_DATE,
              );
              ratingLoads.splice(updateIndex, 1, convertToRatingLoadObject(detail));
            }
            updateNBI(detail);

            //if all required fields entered - close the expanded row
            expandedRows.value = [];
            addingOrEditingLoadRatingDetails.value = false;
            snackbarStore.removeMessage(snackBarId.value);
            inspectionLinksStore.isDirty = true;
            getLoadRatingDetails();
            sortBy.value = previousSortBy.value?.map((x) => x);
          } else {
            if (!validLoadRatingsDetails.value) {
              validationSnackbar.value = true;
            }
            if (!isValidLoadType) {
              duplicateLoadTypeValidationSnackbar.value = true;
            }
          }
        })
        .catch((err) => {
          LOGGER.logException(err);
          changesDetectedRating.value = false;
        });
    };

    const editRating = (rating) => {
      previousSortBy.value = sortBy.value.map((x) => x);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.RATINGS_DATATABLE,
      });
      rating.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(rating.VEH_POST_TYPES);
      rating.readOnly = false;
      addingOrEditingLoadRatingDetails.value = true;
      expandedRows.value.push(rating);
      nextTick(() => loadRatingsDetailsForm.value?.validate());
    };

    const deleteRating = (item) => {
      closeConfirm.value.open(INSPECTION_MESSAGES.LOAD_TYPE_DELETE_CONFIRM, BUTTONS.YES).then((response) => {
        if (response) {
          const index = ratingLoads?.findIndex(
            (a) => a.RATING_KEY === item.RATING_KEY && a.RATING_DATE === item.RATING_DATE,
          );
          if (index > -1) {
            inspectionLinksStore.isDirty = true;
            ratingLoads.splice(index, 1);
            getLoadRatingDetails();
          }
        }
      });
    };

    const addRating = () => {
      previousSortBy.value = sortBy.value.map((x) => x);
      let newRating = clone(RATING_LOAD);
      newRating.BRKEY = loadRatingValue.value.BRKEY;
      newRating.RATING_DATE = getISOFormattedDateNoTime(shownCalculationDate.value);
      newRating.RATING_KEY = loadRatingStore.getNewRatingKey(ratingLoads);
      newRating.isAdd = true;
      newRating.readOnly = false;
      loadRatingDetails.value?.unshift(newRating);
      expandedRows.value.push(newRating);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.RATINGS_DATATABLE,
      });
      addingOrEditingLoadRatingDetails.value = true;
      nextTick(() => loadRatingsDetailsForm.value?.validate());
    };

    const closeRating = () => {
      if (isEditable.value && changesDetectedRating.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              changesDetectedRating.value = false;
              getLoadRatingDetails();
              expandedRows.value = [];
              addingOrEditingLoadRatingDetails.value = false;
              duplicateLoadTypeValidationSnackbar.value = false;
              validationSnackbar.value = false;
              snackbarStore.removeMessage(snackBarId.value);
              snackBarId.value = snackbarStore.showMessage({
                displayText: COMMON_MESSAGE_CONSTANTS.CHANGES_DISCARDED,
                timeout: 10000,
                messageType: SNACKBAR_MESSAGE_TYPES.SUCCESS,
              });
              sortBy.value = previousSortBy.value?.map((x) => x);
            }
          });
      } else {
        getLoadRatingDetails();
        expandedRows.value = [];
        addingOrEditingLoadRatingDetails.value = false;
        duplicateLoadTypeValidationSnackbar.value = false;
        validationSnackbar.value = false;
        snackbarStore.removeMessage(snackBarId.value);
        sortBy.value = previousSortBy.value?.map((x) => x);
      }
    };

    const calculationDates = computed({
      get() {
        let calculationDates = [];
        for (const date of loadRatingStore?.getCalculationDates() ?? []) {
          if (getFormattedDateStringNoTime(date) == getFormattedDateStringNoTime(loadRatingValue.value.RATING_DATE)) {
            calculationDates.push({
              title: getFormattedDateStringNoTime(date) + "*",
              value: date,
            });
          } else {
            calculationDates.push({
              title: getFormattedDateStringNoTime(date),
              value: date,
            });
          }
        }
        return calculationDates.sort((a, b) => new Date(b.value) - new Date(a.value));
      },
    });

    const addRatingSet = (addRatingSetObject) => {
      showAddRatingSetDialog.value = false;
      let storeCalculationDates = loadRatingStore?.getCalculationDates();
      storeCalculationDates.push(addRatingSetObject.calculationDate);
      loadRatingStore.setCalculationDates(storeCalculationDates);
      for (const ratingSet of addRatingSetObject.ratingSet) {
        ratingLoads.push(ratingSet);
      }
      getLoadRatingDetails();
      inspectionLinksStore.isDirty = true;
    };

    const maxCalculationDate = computed(() => {
      const dates = loadRatingStore?.getCalculationDates() || [];
      if (dates.length === 0) return null;
      return dates.reduce((max, date) => {
        const currentDate = new Date(date);
        const maxDate = new Date(max);
        return currentDate > maxDate ? date : max;
      });
    });

    let loadRatingDetails = ref([]);

    const getLoadRatingDetails = () => {
      expandedRows.value = [];
      loadRatingDetails.value = [];

      loadRatingDetails.value = clone(ratingLoads);
      if (!loadRatingDetails.value?.[0]) {
        //remove null values from array(if any)
        loadRatingDetails.value = loadRatingDetails.value?.filter((a) => !!a);
      }
      //filter by shown calculation date
      loadRatingDetails.value = loadRatingDetails.value?.filter(
        (a) => getFormattedDateStringNoTime(a.RATING_DATE) == getFormattedDateStringNoTime(shownCalculationDate.value),
      );
      //set unique key for toggle expansion
      for (const element of loadRatingDetails.value ?? []) {
        element.UNIQUE_KEY = element.LOAD_TYPE + "-" + element.NBI_RATING_IND;
        element.readOnly = true;
      }
      loadRatingDetails.value = loadRatingStore.sortDetails(loadRatingDetails.value);
    };

    const rowClassDetails = (data) => {
      return expandedRows.value?.find((a) => a.UNIQUE_KEY === data.UNIQUE_KEY) ? "rowSelect" : "rowUnselect";
    };

    const updateNBI = (item) => {
      if (item.NBI_RATING_IND == "1") {
        for (let ratingLoad of ratingLoads) {
          if (ratingLoad.NBI_RATING_IND == "1" && ratingLoad.RATING_KEY != item.RATING_KEY) {
            ratingLoad.NBI_RATING_IND = "0";
          }
        }
      }
    };

    const postingFieldRequired = (item) => {
      switch (item.SNBI_POST_STATUS) {
        case "N":
          return false;
        case "C":
          return false;
        case "X":
          return false;
        case "P":
        case "S":
        case "T":
          switch (item.SNBI_POST_CONDITION) {
            case "A":
            case "D":
              return true;
            case "M":
            case "P":
              return true;
            case "O":
              return false;
            case "R":
              return false;
          }
          break;
      }
    };

    const postingHistoryConditionEditable = (item) => {
      return !["N", "C", "X"].includes(item.SNBI_POST_STATUS);
    };

    const postingHistoryConditionRequired = (item) => {
      return ["P", "T", "S"].includes(item.SNBI_POST_STATUS);
    };

    const updateActive = (item) => {
      for (const posting of loadRatingValue.value.postings ?? []) {
        if (item.POSTING_KEY != posting.POSTING_KEY) {
          posting.ACTIVE = "0";
        }
      }
    };

    const addGrossLoadToLoadRatingAndPosting = (item) => {
      if (!item.pVehiclePostTypes.includes("G")) {
        item.pVehiclePostTypes.push("G");
      }
    };

    const updatePostingStatus = (item) => {
      changesDetectedPosting.value = true;
      switch (item.SNBI_POST_STATUS) {
        case "N":
          item.POST_STATUS = "G";
          item.SNBI_POST_CONDITION = "";
          item.pVehiclePostTypes = [];
          break;
        case "C":
          item.POST_STATUS = "C";
          item.SNBI_POST_CONDITION = "";
          item.pVehiclePostTypes = [];
          break;
        case "X":
          item.POST_STATUS = "X";
          item.SNBI_POST_CONDITION = "";
          item.pVehiclePostTypes = [];
          break;
        case "P":
          switch (item.SNBI_POST_CONDITION) {
            case "A":
            case "D":
              item.POST_STATUS = "B";
              item.pVehiclePostTypes = [];
              break;
            case "M":
            case "P":
              item.POST_STATUS = "P";
              addGrossLoadToLoadRatingAndPosting(item);
              break;
            case "O":
              item.POST_STATUS = "A";
              item.pVehiclePostTypes = [];
              break;
            case "R":
              item.POST_STATUS = "R";
              item.pVehiclePostTypes = [];
              break;
          }
          break;
        case "S":
          switch (item.SNBI_POST_CONDITION) {
            case "A":
            case "D":
              item.POST_STATUS = "B";
              item.pVehiclePostTypes = [];
              break;
            case "M":
            case "P":
              item.POST_STATUS = "P";
              addGrossLoadToLoadRatingAndPosting(item);
              break;
            case "O":
              item.POST_STATUS = "D";
              item.pVehiclePostTypes = [];
              break;
            case "R":
              item.POST_STATUS = "R";
              item.pVehiclePostTypes = [];
              break;
          }
          break;
        case "T":
          switch (item.SNBI_POST_CONDITION) {
            case "A":
            case "D":
              item.POST_STATUS = "B";
              item.pVehiclePostTypes = [];
              break;
            case "M":
            case "P":
              item.POST_STATUS = "P";
              addGrossLoadToLoadRatingAndPosting(item);
              break;
            case "O":
              item.POST_STATUS = "E";
              item.pVehiclePostTypes = [];
              break;
            case "R":
              item.POST_STATUS = "R";
              item.pVehiclePostTypes = [];
              break;
          }
          break;
      }
      postingHistoryForm.value.validate();
    };

    const updateVehiclePostTypeAndWeight = (item) => {
      if (["0", "1", "2", "8", "A", "B", "C"].includes(item.LOAD_TYPE)) {
        item.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(activePostingRecord.value?.VEH_POST_TYPES);
        item.VEH_POST_TYPES = loadRatingStore.convertToVehPostTypeObjects(item, item.lrVehiclePostTypes, true);
      }
      updateVehiclePostingValue(item);
    };

    const updateOnLoadTypeOrRatingMethodChange = (item) => {
      changesDetectedRating.value = true;
      updateInventoryAndOperatingRating(item);
      updateVehiclePostTypeAndWeight(item);
      loadRatingStore.updateLegalLoadRatingFactor(item);
      nextTick(() => {
        loadRatingsDetailsForm.value?.validate();
      });
    };

    const updateInventoryAndOperatingRating = (item) => {
      if (loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)) {
        item.IRLOAD = loadRatingStore.getRating(item, "IR");
        item.ORLOAD = loadRatingStore.getRating(item, "OR");
        item.SLC_RATING = null;
      } else {
        item.IR_LOAD_FACTOR = null;
        item.OR_LOAD_FACTOR = null;
      }
    };

    const updateVehiclePostingValue = (item) => {
      const postedPosting = postingHistory?.value?.find(
        (posting) => posting.POST_STATUS == "P" && posting.ACTIVE == "1",
      );
      if (postedPosting) {
        switch (item.LOAD_TYPE) {
          case "0":
          case "1":
          case "8":
          case "A":
          case "C":
            item.VEH_POST_WEIGHT = postedPosting.POST_LIMIT_WEIGHT;
            break;
          case "2":
          case "B":
            if (postedPosting.POST_LIMIT_COMB > 0) {
              item.VEH_POST_WEIGHT = postedPosting.POST_LIMIT_COMB;
            } else {
              item.VEH_POST_WEIGHT = null;
            }
            break;
          default:
            item.VEH_POST_WEIGHT = null;
            break;
        }
      }
    };

    const checkChangeReviewerAction = () => {
      if (loadRatingValue.value.RECOMMEND_RATING_REVIEW == "1") {
        loadRatingValue.value.LR_REVIEW_ACTION = "0";
      }
      if (loadRatingValue.value.RECOMMEND_RATING_REVIEW == "0") {
        loadRatingValue.value.LR_REVIEW_ACTION = "1";
      }
    };

    const isRF = (ratingAnalysisMethod, loadType, isNBI) => {
      if (
        ratingAnalysisMethod == "8" ||
        ratingAnalysisMethod == "D" ||
        ratingAnalysisMethod == "E" ||
        ratingAnalysisMethod == "F"
      ) {
        return true;
      } else if (isNBI && ratingAnalysisMethod == "6" && loadType == "D") {
        return true;
      } else {
        return false;
      }
    };

    const toggleRowDetails = (detail) => {
      detail.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(detail.VEH_POST_TYPES);
      if (expandedRows.value.includes(detail)) {
        const index = expandedRows?.value?.findIndex((d) => d.UNIQUE_KEY == detail.UNIQUE_KEY);
        expandedRows.value.splice(index, 1);
      } else {
        expandedRows.value.push(detail);
      }
    };
    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = isTunnel.value ? tunnelPanels : allPanels;
      } else {
        panel.value = [];
      }
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Load-Rating-Screen", marker: SNACKBAR_MARKER.LOAD_RATING_AND_POSTINGS };
    };

    const assignRatingSet = () => {
      ratingSetAssigned.value = true;
      loadRatingValue.value.RATING_DATE = shownCalculationDate.value;
      loadRatingValue.value.assignedRatingDates.push(shownCalculationDate.value);
    };

    const canEditRatingSet = computed(
      () =>
        getFormattedDateStringNoTime(shownCalculationDate.value) ==
          getFormattedDateStringNoTime(maxCalculationDate.value) && !isShownRatingSetAssignedToAnInspection.value,
    );

    const saveChanges = async () => {
      if (ratingSetAssigned.value) {
        loadRatingValue.value.RATING_APPR_DATE = getISOFormattedDateNoTime(new Date().toISOString());
        loadRatingValue.value.APPROVER_NAME =
          userStore.loggedInUser.given_name + " " + userStore.loggedInUser.family_name;
      }
      loadRatingValue.value.ratingLoads = ratingLoads;
      const isSuccess = await loadRatingStore.saveLoadRating(props.moduleType, loadRatingValue.value, structure.value);
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        await readData();
        ratingSetAssigned.value = false;
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      await readData();
      ratingSetAssigned.value = false;
      inspectionLinksStore.isDirty = false;
    };

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = loadRatingValue?.value?.inspectionComments?.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
      } else {
        loadRatingValue.value.inspectionComments.push(comment);
      }
    };

    const isGrossLoadLocked = (item) => {
      switch (item.SNBI_POST_STATUS) {
        case "P":
        case "S":
        case "T":
          switch (item.SNBI_POST_CONDITION) {
            case "M":
            case "P":
              return true;
          }
          break;
        default:
          return false;
      }
    };

    const isVehiclePostingTypeEditable = (item) => {
      switch (item.SNBI_POST_STATUS) {
        case "P":
        case "S":
        case "T":
          switch (item.SNBI_POST_CONDITION) {
            case "M":
            case "P":
            case "R":
              return true;
          }
          break;
        default:
          return false;
      }
    };

    const isVehiclePostingTypeRequired = (item) => {
      return ["P", "S", "T"].includes(item.SNBI_POST_STATUS) && item.SNBI_POST_CONDITION == "R";
    };

    const getVehiclePostTypeOptions = (item) => {
      let referenceValues = configStore.getReferenceValues(REFERENCE_TABLE.VEHICLE_POSTING_TYPE);
      if (isGrossLoadLocked(item)) {
        let grossLoadIndex = referenceValues?.findIndex((referenceValue) => referenceValue.value == "G");
        referenceValues[grossLoadIndex].disabled = true;
        return referenceValues;
      } else {
        return referenceValues;
      }
    };

    watch(
      loadRatingValue,
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for inspection management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );
    watch(
      () => duplicateLoadTypeValidationSnackbar.value,
      (newVal) => {
        if (newVal) {
          duplicateLoadTypeTextId.value = snackbarStore.showMessage({
            displayText: INSPECTION_MESSAGES.LOAD_RATING_DUPLICATE_LOAD_TYPE,
            timeout: 10000,
            messageType: SNACKBAR_MESSAGE_TYPES.ERROR,
            callback: () => {
              duplicateLoadTypeValidationSnackbar.value = false;
            },
          });
        } else {
          snackbarStore.removeMessage(duplicateLoadTypeTextId.value);
        }
      },
    );

    watch(
      () => [props],
      () => {
        readData();
      },
      { deep: true },
    );
    watch(hasQuickSearchSucceeded, (val) => {
      if (!val) resetDirty.value = true;
    });

    return {
      addRatingSet,
      getLoadRatingDetails,
      updateOnLoadTypeOrRatingMethodChange,
      canEditRatingSet,
      isAssignedRatingSetSelected,
      assignRatingSet,
      shownCalculationDate,
      valid,
      nbiAndAlternateRatingsForm,
      validNbiAndAlternateRatings,
      isDesignMethodRequired,
      loadRatingStore,
      closeRatingSetPopup,
      showAddRatingSetDialog,
      getVehiclePostTypeOptions,
      isGrossLoadLocked,
      isVehiclePostingTypeRequired,
      isVehiclePostingTypeEditable,
      changesDetectedPosting,
      activePostingRecord,
      inspectionStore,
      deleteRating,
      nbiAndAlternateRating,
      updateVehiclePostTypeAndWeight,
      valueInRangeRule,
      changesDetectedRating,
      updateInventoryAndOperatingRating,
      postingHistoryConditionRequired,
      postingHistoryConditionEditable,
      addingOrEditingLoadRatingPostingDetails,
      addingOrEditingLoadRatingDetails,
      postingFieldRequired,
      updatePostingStatus,
      calculationDates,
      ratingSetAssigned,
      addingOrEditing,
      headersPostingEditable,
      detailsHeadersEditable,
      isManagement,
      saveRating,
      savePosting,
      closeConfirm,
      BUTTONS,
      validPostingHistory,
      validLoadRatingsDetails,
      loadRatingsDetailsForm,
      closePosting,
      closeRating,
      editRating,
      editPosting,
      postingHistoryForm,
      addRating,
      addPosting,
      readData,
      setUpdatedComment,
      MODULE_TYPES,
      cancelChanges,
      saveChanges,
      isRF,
      checkChangeReviewerAction,
      detailsHeaders,
      sortBy,
      toggleRowPosting,
      rowClassPosting,
      expandedRowsPosting,
      panel,
      REFERENCE_TABLE,
      isEditable,
      loadRatingValue,
      INSPECTION_COMMENTS,
      loadRatingDetails,
      expandedRows,
      configStore,
      inspCommentMaxLength,
      rowClassDetails,
      ROUNDING_FACTOR,
      getStructureType,
      isTunnel,
      notesMaxLength,
      showConsiderationsDialog,
      CONSIDERATIONS_POINTS,
      loadRatingsForm,
      validate,
      validLoadRatings,
      headersPosting,
      postingHistory,
      toggleRowDetails,
      getFormattedDateStringNoTime,
      sortByPosting,
      toggleAllPanels,
      printD491,
    };
  },
  components: {
    RatingSetPopup,
    IconTooltip,
    ConfirmDialog,
    ManagementCommentTypeTextField,
    DataTableHeader,
    LabelSelect,
    LabelText,
    LabelCheckbox,
    LabelDatefield,
    CommentTypeTextField,
    ExpandCollapseToggle,
    ValidationCountsHeader,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/general" as g;
@use "@/styles/colors" as c;
.handleFlex {
  flex: none !important;
}

.details-text :deep(.v-input__details) {
  display: flex !important;
  justify-content: space-between !important;
}

.details-text :deep(.v-messages) {
  display: none !important;
}

@media #{g.$p-breakPointLgAndUp} {
  .reviewActionField {
    padding-top: 5px !important;
  }
}
.alignCenter {
  text-align: center;
}
.alignEnd {
  text-align: end;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
</style>
